import { useTranslation } from 'react-i18next'
import { useState, useEffect, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import LogoWhite from '../common/logo-white'
import DrawerMenuButton from './drawer-menu-button'
import MoneyIcon from '../../assets/icons/money-icon.svg'
import { UserContext } from '../../contexts/user.context'
import CryptoIcon from '../../assets/icons/crypto-icon.svg'
import WalletIcon from '../../assets/icons/wallet-icon.svg'
import MetricsIcon from '../../assets/icons/metric-icon.svg'
import HomeIcon from '../../assets/icons/home-menu-icon.svg'
import ReportsIcon from '../../assets/icons/reports-icon.svg'
import UsersIcon from '../../assets/icons/users-menu-icon.svg'
import ConfigIcon from '../../assets/icons/config-menu-icon.svg'
import SignOutIcon from '../../assets/icons/sign-out-menu-icon.svg'
import DocumentsIcon from '../../assets/icons/documents-menu-icon.svg'
import PaymentMovementsIcon from '../../assets/icons/payment-movements-icon.svg'
import UsersManagementIcon from '../../assets/icons/users-management-menu-icon.svg'
import CustomerCompaniesManagementIcon from '../../assets/icons/clients-management-icon.svg'

const DrawerContent = ({ handleCloseSession }: { handleCloseSession: () => void }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation(['dashboard'])
  const { userSession } = useContext(UserContext)
  const [currentSection, setCurrentSection] = useState('')
  // const [customerCompanyId, setCustomerCompanyId] = useState('')
  const [openPaymentsSubmenu, setOpenPaymentsSubmenu] = useState(false)
  // const [openDocumentsSubmenu, setOpenDocumentsSubmenu] = useState(false)

  useEffect(() => {
    setCurrentSection(location.pathname)
  }, [location])

  // useEffect(() => {
  //   if (userSession && userSession.role === 'super-admin-client') {
  //     setCustomerCompanyId(String(userSession.belongsTo))
  //   }
  // }, [userSession])

  return (
    <div className="drawer-content-container">
      <div
        style={{ cursor: 'pointer' }}
        onClick={() => navigate('/')}
      >
        <LogoWhite />
      </div>
      <div
        style={{ height: '620px' }}
        className="drawer-menu-container"
      >
        <DrawerMenuButton
          icon={
            <img
              src={HomeIcon}
              alt="home-icon"
            />
          }
          buttonText={t('drawerButtonsTexts.home')}
          active={currentSection === '/'}
          sx={{ borderBottom: '1px dashed #2ED3B7' }}
          handleTriggerMenuAction={() => navigate('/')}
        />
        {(userSession?.role === 'super-admin' || userSession?.role === 'admin') && (
          <>
            <DrawerMenuButton
              icon={
                <img
                  src={CustomerCompaniesManagementIcon}
                  alt="customer-companies-management-icon"
                />
              }
              buttonText={t('drawerButtonsTexts.clientsManagement')}
              active={currentSection === '/customer-companies'}
              sx={{ borderBottom: '1px dashed #2ED3B7' }}
              handleTriggerMenuAction={() => navigate('/customer-companies')}
            />
            {userSession?.subRole && userSession?.subRole === 'crypto-specialist' && (
              <DrawerMenuButton
                icon={
                  <img
                    src={CryptoIcon}
                    alt="crypto-icon"
                  />
                }
                buttonText={t('drawerButtonsTexts.crypto')}
                active={currentSection === '/crypto'}
                sx={{ borderBottom: '1px dashed #2ED3B7' }}
                handleTriggerMenuAction={() => navigate('/crypto')}
              />
            )}
          </>
        )}
        {/* {userSession && (userSession.role === 'super-admin' || userSession.role === 'admin' || userSession.role === 'admin-builder') && (
          <>
            {(!userSession?.subRole ||
              (userSession?.subRole && userSession?.subRole !== 'compliance-specialist' && userSession?.subRole !== 'payments-specialist' && userSession?.subRole !== 'reconciliation-specialist')) && (
              <>
                <DrawerMenuButton
                  icon={
                    <img
                      src={DocumentsIcon}
                      alt="documents-icon"
                    />
                  }
                  nestedMenu
                  buttonText={t('drawerButtonsTexts.documents')}
                  sx={{ borderBottom: '1px dashed #2ED3B7' }}
                  active={currentSection.indexOf('/documents') !== -1}
                  handleOpenSubmenu={(openSubmenuState) => setOpenDocumentsSubmenu(openSubmenuState)}
                  openSubmenu={currentSection.indexOf('/documents') !== -1 ? true : openDocumentsSubmenu}
                  nestedMenuItems={[
                    { name: t('drawerButtonsTexts.documentStatus.reviewing'), link: '/documents-to-review', selected: currentSection.indexOf('/documents-to-review') !== -1 },
                    { name: t('drawerButtonsTexts.documentStatus.readyForDisperse'), link: '/documents-ready', selected: currentSection.indexOf('/documents-ready') !== -1 },
                    { name: t('drawerButtonsTexts.documentStatus.completed'), link: '/documents-completed', selected: currentSection.indexOf('/documents-completed') !== -1 }
                  ]}
                />
                <DrawerMenuButton
                  icon={
                    <img
                      src={MoneyIcon}
                      alt="payments-icon"
                    />
                  }
                  nestedMenu
                  buttonText={t('drawerButtonsTexts.payments')}
                  sx={{ borderBottom: '1px dashed #2ED3B7' }}
                  active={currentSection.indexOf('/payments') !== -1}
                  handleOpenSubmenu={(openSubmenuState) => setOpenPaymentsSubmenu(openSubmenuState)}
                  openSubmenu={currentSection.indexOf('/payments') !== -1 ? true : openPaymentsSubmenu}
                  nestedMenuItems={
                    userSession?.role === 'super-admin-client'
                      ? [
                          { name: t('drawerButtonsTexts.paymentStatus.reviewing'), link: '/payments-to-review', selected: currentSection.indexOf('/payments-to-review') !== -1 },
                          { name: t('drawerButtonsTexts.paymentStatus.rejected'), link: '/payments-rejected', selected: currentSection.indexOf('/payments-rejected') !== -1 },
                          { name: t('drawerButtonsTexts.paymentStatus.withNovelties'), link: `/payments-with-novelties/${customerCompanyId}`, selected: currentSection.indexOf('/payments-ready') !== -1 },
                          { name: t('drawerButtonsTexts.paymentStatus.readyForDisperse'), link: '/payments-completed', selected: currentSection.indexOf('/payments-ready') !== -1 }
                        ]
                      : [
                          { name: t('drawerButtonsTexts.paymentStatus.reviewing'), link: '/payments-to-review', selected: currentSection.indexOf('/payments-to-review') !== -1 },
                          { name: t('drawerButtonsTexts.paymentStatus.rejected'), link: '/payments-rejected', selected: currentSection.indexOf('/payments-rejected') !== -1 },
                          { name: t('drawerButtonsTexts.paymentStatus.readyForDisperse'), link: '/payments-completed', selected: currentSection.indexOf('/payments-ready') !== -1 }
                        ]
                  }
                />
              </>
            )}
          </>
        )} */}
        {userSession && (userSession.role === 'super-admin-client' || userSession.role === 'admin-client' || userSession.role === 'admin-client-builder') && (
          <>
            {(!userSession?.subRole || (userSession?.subRole && userSession?.subRole !== 'paxum-customer-service-specialist')) && (
              <DrawerMenuButton
                icon={
                  <img
                    src={MoneyIcon}
                    alt="payments-icon"
                  />
                }
                nestedMenu
                buttonText={t('drawerButtonsTexts.payments')}
                sx={{ borderBottom: '1px dashed #2ED3B7' }}
                active={
                  currentSection.indexOf('/customer-company-batches/') !== -1 ||
                  currentSection.indexOf('/customer-company-payments/') !== -1 ||
                  currentSection.indexOf('/documents') !== -1 ||
                  currentSection.indexOf('/payments') !== -1
                }
                handleOpenSubmenu={(openSubmenuState) => setOpenPaymentsSubmenu(openSubmenuState)}
                openSubmenu={
                  currentSection.indexOf('/customer-company-batches/') !== -1 ||
                  currentSection.indexOf('/customer-company-payments/') !== -1 ||
                  currentSection.indexOf('/documents') !== -1 ||
                  currentSection.indexOf('/payments') !== -1
                    ? true
                    : openPaymentsSubmenu
                }
                nestedMenuItems={
                  !userSession?.subRole || (userSession?.subRole && userSession?.subRole !== 'compliance-specialist')
                    ? [
                        { name: t('drawerButtonsTexts.paymentsSubmenu.batches'), link: `/customer-company-batches/${userSession.belongsTo}`, selected: currentSection.indexOf('/customer-company-batches/') !== -1 },
                        { name: t('drawerButtonsTexts.paymentsSubmenu.individual'), link: `/customer-company-payments/${userSession.belongsTo}`, selected: currentSection.indexOf('/customer-company-payments/') !== -1 }
                      ]
                    : [{ name: t('drawerButtonsTexts.paymentsSubmenu.individual'), link: `/customer-company-payments/${userSession.belongsTo}`, selected: currentSection.indexOf('/customer-company-payments/') !== -1 }]
                }
              />
            )}
            {userSession && (userSession.role === 'super-admin-client' || userSession.role === 'admin-client') && (
              <DrawerMenuButton
                icon={
                  <img
                    src={DocumentsIcon}
                    alt="documents-icon"
                  />
                }
                buttonText={t('drawerButtonsTexts.transactions')}
                sx={{ borderBottom: '1px dashed #2ED3B7' }}
                active={currentSection.indexOf('/customer-company-payments-history/') !== -1}
                handleTriggerMenuAction={() => navigate(`/customer-company-payments-history/${userSession.belongsTo}`, { state: { previousPath: '/' } })}
              />
            )}
          </>
        )}
        {userSession?.belongsTo !== 'holdings' && (
          <DrawerMenuButton
            icon={
              <img
                src={UsersIcon}
                alt="users-icon"
              />
            }
            buttonText={t('drawerButtonsTexts.benificiaries')}
            sx={{ borderBottom: '1px dashed #2ED3B7' }}
            active={currentSection === '/beneficiaries'}
            handleTriggerMenuAction={() => navigate('/beneficiaries')}
          />
        )}
        {(userSession?.role === 'super-admin-client' || userSession?.role === 'admin-client') && (
          <>
            {(!userSession?.subRole || (userSession?.subRole && userSession?.subRole !== 'paxum-customer-service-specialist')) && (
              <DrawerMenuButton
                icon={
                  <img
                    src={MetricsIcon}
                    alt="metricts-icon"
                  />
                }
                buttonText={t('drawerButtonsTexts.insights')}
                active={currentSection === '/insights'}
                sx={{ borderBottom: '1px dashed #2ED3B7' }}
                handleTriggerMenuAction={() => navigate('/insights')}
              />
            )}
          </>
        )}
        {userSession?.role === 'super-admin-client' && !userSession?.subRole && (
          <DrawerMenuButton
            icon={
              <img
                src={WalletIcon}
                alt="wallet-icon"
              />
            }
            buttonText={t('drawerButtonsTexts.pockets')}
            active={currentSection === '/pockets'}
            sx={{ borderBottom: '1px dashed #2ED3B7' }}
            handleTriggerMenuAction={() => navigate('/pockets')}
          />
        )}
        {userSession?.subRole && userSession?.subRole === 'reconciliation-specialist' && (
          <DrawerMenuButton
            icon={
              <img
                src={PaymentMovementsIcon}
                alt="payment-movements-icon"
              />
            }
            buttonText={t('drawerButtonsTexts.paymentMovements')}
            active={currentSection.indexOf('/payment-movements') !== -1}
            sx={{ borderBottom: '1px dashed #2ED3B7' }}
            handleTriggerMenuAction={() => navigate(`/payment-movements`, { state: { previousPath: '/' } })}
          />
        )}
        {userSession?.role && userSession?.role.indexOf('builder') === -1 && (
          <>
            {(!userSession?.subRole || (userSession?.subRole && userSession?.subRole !== 'paxum-customer-service-specialist')) && (
              <DrawerMenuButton
                icon={
                  <img
                    src={ReportsIcon}
                    alt="reports-icon"
                  />
                }
                buttonText={t('drawerButtonsTexts.generatedReports')}
                active={currentSection.indexOf('/requested-reports/') !== -1}
                sx={{ borderBottom: '1px dashed #2ED3B7' }}
                handleTriggerMenuAction={() => navigate(`/requested-reports/${userSession.belongsTo}`, { state: { previousPath: '/' } })}
              />
            )}
          </>
        )}
        {(userSession?.role === 'super-admin-client' || userSession?.role === 'super-admin' || userSession?.role === 'admin' || userSession?.role === 'admin-client') && (
          <>
            {(!userSession?.subRole ||
              (userSession?.subRole &&
                userSession?.subRole !== 'compliance-specialist' &&
                userSession?.subRole !== 'payments-specialist' &&
                userSession?.subRole !== 'reconciliation-specialist' &&
                userSession?.subRole !== 'paxum-payments-specialist' &&
                userSession?.subRole !== 'paxum-customer-service-specialist')) && (
              <DrawerMenuButton
                icon={
                  <img
                    src={UsersManagementIcon}
                    alt="users-management-icon"
                  />
                }
                buttonText={t('drawerButtonsTexts.userManagement')}
                active={currentSection === '/system-users'}
                sx={{ borderBottom: '1px dashed #2ED3B7' }}
                handleTriggerMenuAction={() => navigate('/system-users')}
              />
            )}
          </>
        )}
        <DrawerMenuButton
          icon={
            <img
              src={ConfigIcon}
              alt="config-icon"
            />
          }
          buttonText={t('drawerButtonsTexts.configuration')}
          active={currentSection === '/account'}
          sx={{ borderBottom: '1px dashed #2ED3B7' }}
          handleTriggerMenuAction={() => navigate('/account')}
        />
        <DrawerMenuButton
          icon={
            <img
              src={SignOutIcon}
              alt="sign-out-icon"
            />
          }
          buttonText={t('drawerButtonsTexts.logOut')}
          handleTriggerMenuAction={handleCloseSession}
          sx={{ borderBottom: 'none', marginBottom: '30px' }}
          // sx={{ borderTop: '1px dashed #2ED3B7', position: 'absolute', bottom: '55px', width: '100%', boxSizing: 'border-box' }}
        />
      </div>
    </div>
  )
}

export default DrawerContent
